import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Box, Text } from "@theme-ui/components"

const ImageBlock = ({ block, colorMode }) => {
  console.log(colorMode)
  const { image, imageBlack } = block

  const imageToUse = colorMode[0] === "dark" && imageBlack ? imageBlack : image

  return (
    <Box
      mb={5}
      sx={{
        width: ["100vw", "100vw", "80vw"],
        position: "relative",
        left: ["calc(-50vw + 50%)", "calc(-50vw + 50%)", "calc(-40vw + 50%)"],
      }}
    >
      {imageToUse && imageToUse.gatsbyImageData && (
        <Box
          sx={{
            mb: 2,
            ".gatsby-image-wrapper": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <GatsbyImage image={imageToUse.gatsbyImageData} alt="" />
        </Box>
      )}
      {imageToUse && imageToUse.title && (
        <Box>
          <Text variant="caption">{imageToUse.title}</Text>
        </Box>
      )}
    </Box>
  )
}

export default ImageBlock
